export default __webpack_public_path__ + "partials/button_facebook.hbs";